import React, { useState } from 'react'

import MenuList, { MenuListLabelProps } from '../MenuList'
import Menu, { MenuProps } from './Menu'

import { MenuVariant } from '~lib/ui-kit/MenuLayout'

export type SubmenuProps = React.HTMLAttributes<HTMLElement> & {
  active?: boolean
  selected?: boolean
  creatable?: MenuProps['creatable']
  label: string
  icon?: React.ReactNode
  endIcon?: React.ReactNode
  placement?: MenuProps['placement']
  searchable?: MenuProps['searchable']
  disableInnerSearch?: MenuProps['disableInnerSearch']
  menuLabel?: string
  onCreate?: MenuProps['onCreate']
  onSearch?: MenuProps['onSearch']
  trigger?: MenuProps['trigger']
  width?: MenuProps['width']
  maxWidth?: MenuProps['maxWidth']
  minWidth?: MenuProps['minWidth']
  variant?: MenuVariant
  open?: MenuProps['open']
  onChangeOpen?: MenuProps['onChangeOpen']
  multiple?: MenuProps['multiple']
  labelClassName?: MenuListLabelProps['labelClassName']
}

function Submenu({
  active,
  children,
  label,
  placement = 'right-start',
  menuLabel,
  endIcon,
  searchable,
  creatable,
  onSearch,
  onCreate,
  variant,
  icon,
  onClick,
  selected,
  trigger = 'click',
  width,
  maxWidth,
  minWidth,
  open,
  onChangeOpen,
  multiple,
  labelClassName,
  ...elementProps
}: SubmenuProps) {
  const [menuItemEl, setMenuItemEl] = useState<HTMLElement>(null)

  return (
    <MenuList.Item>
      <MenuList.Label
        {...elementProps}
        onClick={onClick}
        aria-haspopup
        ref={setMenuItemEl}
        active={active}
        selected={selected}
        icon={icon}
        endIcon={endIcon}
        labelClassName={labelClassName}
      >
        {label}
      </MenuList.Label>

      <Menu
        open={open}
        onChangeOpen={onChangeOpen}
        trigger={trigger}
        variant={variant}
        anchorEl={menuItemEl}
        placement={placement}
        label={menuLabel}
        searchable={searchable}
        creatable={creatable}
        onSearch={onSearch}
        onCreate={onCreate}
        width={width}
        maxWidth={maxWidth}
        minWidth={minWidth}
        multiple={multiple}
        {...elementProps}
      >
        {children}
      </Menu>
    </MenuList.Item>
  )
}

export default Submenu
